'use client'

import { useEffect } from 'react'

import { useShallow } from 'zustand/react/shallow'

import { selectGraftcodeOnboardingHydrateState } from '@apps/graftcode-onboarding/stores/graftcode-onboarding.selector'
import { useGraftcodeOnboardingStore } from '@apps/graftcode-onboarding/stores/graftcode-onboarding.store'

export function useGraftcodeOnboardingHydrate() {
  const { hydrate, hydrated } = useGraftcodeOnboardingStore(useShallow(selectGraftcodeOnboardingHydrateState))

  useEffect(() => {
    if (!hydrated) {
      hydrate()
    }
  }, [hydrate, hydrated])
}
